<template>
    <div class="page"> 
        <Menu :curName="'关于我们'"/>
        <div class="container">
            <div class="menu-list" >
                <div class="item1 " v-for="(item,index) in menuList" :key="index" @click="menuSelect(index)" :class="index == curMenuIndex ? 'selected':''">
                    {{item.name}}
                </div>
            </div>
            <div class="about-list" v-show="curMenuIndex == 0">
                <div class="item">
                    <div class="title">北京祈山志远健康发展有限公司</div>
                    <div class="enTitle">Beijing Qishan Zhiyuan Health Development Co., Ltd.</div>
                    <div class="desc">北京祈山志远健康管理有限公司是一家专注于 中医经络推拿职业技能培训及认证 的专业机构，致力于培养高素质推拿技术人才，推动行业标准化发展。公司通过系统化的课程体系、权威的资格认证以及产学研结合的模式，为行业输送专业人才，提升整体服务水平,共同打造“祈山致远”品牌。</div>
                </div>
                <div class="item">
                    <div class="title">成都祈山志远智慧科技有限公司</div>
                    <div class="enTitle">Chengdu Qishan Zhiyuan Intelligent Technology Co., Ltd.</div>
                    <div class="desc"> 成都祈山志远智慧科技有限公司作为北京祈山致远健康管理有限公司的战略合作子公司，是一家依托于 经络推拿行业的智慧科技企业，专注于为行业提供 信息化、数字化、智能化解决方案。其业务涵盖 SaaS管理系统、智能推拿辅助设备研发、大数据健康分析平台 等，助力传统推拿行业向智慧化升级，共同打造“祈山致远”品牌</div>
                </div>
                <div class="item">
                    <div class="title">“祈山致远”品牌战略合作联盟</div>
                    <div class="enTitle">"Qishan Zhiyuan" Brand Strategic Cooperation Alliance</div>
                    <div class="desc">“祈山致远”品牌与全国多家经络推拿连锁门店、儿童友好机构、学校及健康管理机构、儿童养教疏护综合体、 建立深度战略合作，共同打造“祈山致远”健康品牌。</div>
                </div>
            </div>
            <div class="about-list" v-show="curMenuIndex == 1">
                <img src="/imgs/about_1.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
             <div class="about-list" v-show="curMenuIndex == 2">
                <img src="/imgs/about_2.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
            <div class="about-list" v-show="curMenuIndex == 3">
                <img src="/imgs/about_3.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
             <div class="about-list" v-show="curMenuIndex == 4">
                <img src="/imgs/about_4.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
             <div class="about-list" v-show="curMenuIndex == 5">
                <img src="/imgs/about_5.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
             <div class="about-list" v-show="curMenuIndex == 6">
                <img src="/imgs/about_6.png" style="width:100%;height:auto;object-fit: scale-down;"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from "@/components/Menu.vue";

    export default { 
        data() {
            return {
                menuList:[
                    {name:'合作联盟'},
                    {name:'投资运营规划部'},
                    {name:'教学与培训部门'},
                    {name:'合作发展部门'},
                    {name:'质量服务部门'},
                    {name:'综合管理部门'},
                    {name:'智慧科技部发展'},
                ],
                curMenuIndex:0,
            };
        },
        components: {
            Menu
        },
        mounted() {
           
        },
        methods: {
            menuSelect(index){
                this.curMenuIndex = index;
            },
            loadData(id) {
               
            }
        },
        computed: {}
    };
</script>

<style lang="scss" scoped>
    body,
    .page {
        left: 0;
        bottom: 0;
        right: 0;
    }
    .container{
        display: flex;flex-direction:row;margin: 0 auto;width: 1200px;justify-content: space-between;
        .menu-list{
            width: 200px;margin-right:20px;margin-bottom:60px;
            .item1{
                text-align: center;
                color: #4f4138 !important;font-size: 24px;border-bottom: 1px solid #edd4bf;margin-top: 20px;cursor: pointer;padding: 20px 0;
            }
            .selected{
                background: url(/img/left-ok2.png) 20% 50% no-repeat !important;font-weight: 600;
            }
        }
        .about-list{
            display: flex;flex-direction: row;flex:1;
            padding: 40px 0;
            .item{
                margin: 10px 10px;flex:1;
                .title{
                    font-size: 18px;color: #313131;
                }
                .enTitle{
                    font-size: 14px;margin-top: 20px;color: #666666;
                }
                .desc{
                    margin-top: 32px;color:#777777;font-size: 14px;text-indent: 24px;
                }
            }
        }
    }
    
</style>
